<template>
  <master-layout id="contentBookmark">
    <div v-if="!isLoading"
    class="w-[100vw] overflow-x-hidden overflow-y-scroll flex flex-col lg:flex-1 h-[calc(100svh-73px)] font-aktiv-grotesk pb-[64px] md:pb-[104px]"
  >
  <div
      class="w-full md:max-w-[896px] md:mx-auto px-[24px] pt-[24px] md:pt-[40px] lg:px-0"
    >
      <div class="block mb-[24px]">
        <img
          src="../../../public/assets/icons/go-back-chevron.svg"
          alt="Back Icon"
          class="cursor-pointer"
          @click="back()"
        />
      </div>
      <div>
        <p
          class="text-grey-100 text-[32px] leading-[40px] mt-[24px] font-aktiv-grotesk-medium"
        >
          {{ myListHeader }}
        </p>
        <div
          v-if="
            allBookMarkList[0].resources && allBookMarkList[0].resources.length
          "
          v-for="(item, index) in allBookMarkList"
          class="mt-[16px]"
        >
          <div class="mt-[36px] flex flex-row flex-wrap gap-x-[16px] gap-y-[16px] md:gap-y-[64px]">
              <ResourceCard
                v-for="(item, index) in item.resources"
                :key="`${item.slug}-${item.type}`"
                :image-url="item.thumbnail"
                :title="item.title"
                :slug="item.slug"
                :type="item.type"
                :tag-slug="tagSlug"
                :duration="item.duration"
                :is-exclusive="item.isCVPExclusive"
                :is-audio="item.isAudio"
                :avail-translations="item.availTranslations"
                :resource-translations="item.resourceTranslations"
                class="!pr-0"
                @openLanguageModal="() => {}"
              />
          </div>
        </div>
        <div v-else>
          <div class="text-center mt-[60px] ">
            <h1 class="text-[24px] leading-[32px] font-bold">Your List is Empty</h1>
            <p class="mt-[16px] text-[16px] leading-[20px]">As you explore resources, tap the <img  src="/assets/images/bookmark.svg" 
      alt="bookmark" class="inline"/> icon <br/> to save it here.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
      v-if="isLoading"
      class="w-screen h-screen flex items-center justify-center"
    >
      <loading-state />
    </div>
  </master-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ResourceCard from "@/components/ResourcesPage/PlaybackResources/ResourceCard.vue";
import ResourceCardThumbnail from "@/components/ResourcesPage/PlaybackResources/ResourceCardThumbnail.vue";
import VideoTag from "@/components/ResourcesPage/PlaybackResources/VideoTag.vue";
import { bookmark } from "ionicons/icons";
import LoadingState from "@/components/common/LoadingState.vue";

export default {
  name: "ResourceSearch",
  components: {
    ResourceCard,
    ResourceCardThumbnail,
    VideoTag,
    LoadingState,
  },
  data() {
    return {
      bookmarkIcon: bookmark,
    };
  },
  computed: {
    ...mapState("filter", ["allBookMarkList", "isLoading"]),
    ...mapGetters("filter", ["myListHeader"]),
  },
  async ionViewDidEnter() {
    const locale = "en";
    await Promise.all([
      await this.$store.dispatch("filter/fetchBookMarkLists", {
        locale: locale,
        conferenceType: "GIC",
      }),
  ]);
  },
  async ionViewWillLeave() {},
  methods: {
    back() {
      this.$router.back();
    },
  },
};
</script>
<style scoped>
@media all and (min-width: 768px) {
  ::v-deep(.swiper-wrapper) {
    padding-left: 0;
  }
}
</style>
